import React from 'react';
import { Hero } from './components/Hero';
import { ForYouSection } from './components/ForYouSection';
import { WhatsInside } from './components/WhatsInside';
import { Outcomes } from './components/Outcomes';
import { PurchaseSection } from './components/PurchaseSection';
import { Bonuses } from './components/Bonuses';
import { Reviews } from './components/Reviews';
import { Faq } from './components/Faq';
export function App() {
  return <div className="min-h-full w-full overflow-x-hidden bg-cream-100 font-sans" data-id="element-0" data-mp="2rlf5yrr73m2b">
      <main className="bg-grid mx-auto w-full max-w-[460px] overflow-x-hidden" data-id="element-1" data-mp="2mmvob3jmwwfr">
        <Hero data-id="element-2" data-mp="31aysc7e49y1x" />
        <ForYouSection data-id="element-3" data-mp="31brzh9gzmpkl" />
        <WhatsInside data-id="element-4" data-mp="31c1j8fbfw0hu" />
        <Outcomes data-id="element-5" data-mp="31cjjro54x0vk" />
        <PurchaseSection data-id="element-6" data-mp="2wk9xqj754kyk" />
        <Bonuses data-id="element-7" data-mp="2wiyvwox99na3" />
        <Reviews data-id="element-8" data-mp="2wifhhi6tdh0t" />
        <Faq data-id="element-9" data-mp="2whxaprmizken" />
      </main>
    </div>;
}